export const STATUS_CANCELLED = 'canceled';
export const STATUS_COMPLETED = 'completed';
export const STATUS_ERROR = 'error';
export const STATUS_PENDING = 'pending';
export const STATUS_SPLIT = 'split';
export const STATUS_UNDER_REVIEW = 'under_review';

/**
 * @typedef {Object} Booking
 * @property {number} id
 * @property {string} reservation_status
 * @property {string} cancelled_at
 * @property {'deferred'|'direct'|'invoice'} payment_method
 */

/**
 * Checks whether booking is under review.
 *
 * @param {Booking} booking
 * @param {string} booking.reservation_status
 *
 * @returns {boolean}
 */
const isUnderReview = (booking) => {
    return booking.reservation_status === STATUS_UNDER_REVIEW;
};

/**
 * Check whether booking is cancelled.
 *
 * @param {Booking} booking
 * @param {string} booking.cancelled_at
 *
 * @returns {boolean}
 */
export const isCancelled = (booking) => {
    const { cancelled_at } = booking;

    return !!cancelled_at;
};

/**
 * Returns the booking status.
 *
 * @param {Booking} booking
 * @param {string} booking.reservation_status
 *
 * @returns {string}
 */
export const getBookingStatus = (booking) => {
    const { reservation_status } = booking;

    if (isCancelled(booking) && !isUnderReview(booking)) {
        return STATUS_CANCELLED;
    }

    return reservation_status;
};

/**
 * Returns true if payment-method is deferred.
 *
 * @param {Booking} booking
 * @returns {boolean}
 */
export const isDeferred = (booking) => {
    return booking.payment_method === 'deferred';
};

/**
 * Returns true if payment-method is invoice.
 *
 * @param {Booking} booking
 * @returns {boolean}
 */
export const isInvoiced = (booking) => {
    return booking.payment_method === 'invoice';
};

/**
 * Returns true if payment-method is direct, which implies payable.
 *
 * @param {Booking} booking
 * @returns {boolean}
 */
export const isPaid = (booking) => {
    return booking.payment_method === 'direct';
};



// WEBPACK FOOTER //
// ./src/helpers/booking.js